import { useEffect, useState } from "react";

export function isStandaloneApp() {
  return (
    window.matchMedia("(display-mode: standalone)").matches
    || window.navigator.standalone === true
  );
}

export default function PwaLaunchSplash() {
  const [visible, setVisible] = useState(() => isStandaloneApp());

  useEffect(() => {
    if (!isStandaloneApp()) {
      return undefined;
    }
    const timeoutId = window.setTimeout(() => setVisible(false), 950);
    return () => window.clearTimeout(timeoutId);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-white"
      aria-label="Membuka aplikasi"
      data-testid="pwa-launch-splash"
    >
      <img
        src="/mascot.png"
        alt=""
        className="w-[min(78vw,30rem)] max-w-none object-contain"
        data-testid="pwa-launch-splash-mark"
      />
    </div>
  );
}